var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCause02 = function SvgIconCause02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#906F2F",
    d: "M21.583 10.5q1.75 1.855 1.75 4.666c0 4.044-4.316 4.99-6.416 10.5q-1.168-1.005-1.167-2.916c0-4.062 5.833-6.172 5.833-12.25m-4.666-4.667q2.1 2.166 2.1 4.667c0 5.776-7.053 6.64-5.6 15.167Q10.5 23.636 10.5 19.833c0-3.879 6.417-7 6.417-14m-5.25-4.666Q14 4.082 14 6.417c0 7.291-9.917 9.592-4.667 19.25-3.052-.677-5.25-3.5-5.25-7 0-7.584 7.584-8.75 7.584-17.5"
  })));
};
export default SvgIconCause02;